<template>
  <div class="subscription-licences">
    <subscription-licences-list
        v-if="vehicle"
        :vehicle-id="vehicle.id"
        :organization-id="vehicle.organization ? vehicle.organization.id : null"
    ></subscription-licences-list>
  </div>
</template>

<script>
import SubscriptionLicencesList from "@/components/elements/SubscriptionLicencesList.vue"

export default {
  components: {
    SubscriptionLicencesList,
  },

  computed: {
    vehicle() {
      return this.$parent.vehicle ?? null
    },
  },
}
</script>
